import api from './api';

export interface Status {
  id: string;
  nome: string;
  codigo: number;
}

export interface StatusOrdemCompra {
  codigo: number;
  id: string;
  nome: string;
  ordemCompraId: string;
}

export interface StepsTimeline {
  fluxoEtapaId: string;
  isRealizado: boolean;
  isPendente: boolean;
  nome: string;
  dataRealizado: Date;
  dataForecast: Date;
  ordem: number;
  status: string;
  statusEtapaFluxoProcessoId: string;
  ordemCompraRodadaNegociacaoId?: string
  ordemCompraFluxoProcessoId?: string
  dataRealConclusao?: Date;
  isAtual: boolean;
}

export const getAllStatusEncerramento = () => api.get<Status[]>('status/encerramento');
export const getAllStatusEncerramentoOptions = () =>
  getAllStatusEncerramento().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllStatusSeguroGarantia = () => api.get<Status[]>('status/seguroGarantia');
export const getAllStatusSeguroGarantiaOptions = () =>
  getAllStatusSeguroGarantia().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllStatusMedicao = () => api.get<Status[]>('status/medicao');
export const getAllStatusMedicaoOptions = () =>
  getAllStatusMedicao().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllStatusAutorizacaoPagamento = () => api.get<Status[]>('status/getAllStatusAutorizacaoPagamento');
export const getAllStatusAutorizacaoPagamentoOptions = () =>
  getAllStatusAutorizacaoPagamento().then(status =>
    (status || []).map(t => ({ text: t.nome, value: t.id.toString() })),
  );

export const getAllStatusAutorizacao = () => api.get<Status[]>('status/getAllStatusAutorizacao');
export const getAllStatusAutorizacaoOptions = () =>
  getAllStatusAutorizacao().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllStatusSasProposta = () => api.get<Status[]>('status/sasProposta');
export const getAllStatusSasPropostaOptions = () =>
  getAllStatusSasProposta().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllSasStatusDocumentoOrdemCompra = () => api.get<Status[]>('sasDocumentoOrdemCompra/getAllSasStatusDocumentoOrdemCompra');
export const getAllSasStatusDocumentoOrdemCompraOptions = () =>
  getAllSasStatusDocumentoOrdemCompra().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));



export const getStatusOrdem = (ordemId: string) => api.get<StatusOrdemCompra>(`ordemCompra/status/${ordemId}`);

interface StatusOrdemCompraFluxo {
  statusOrdemCompraTexto: string;
  statusOrdemCompraId: string;
}

export const getStatusOrdemCompraFluxo = (ordemId: string) =>
  api.get<StatusOrdemCompraFluxo>(`ordemCompra/status/fluxo/${ordemId}`);

export const getStatusOCFixo = (ordemId: string) => api.get<StatusOrdemCompra[]>(`ordemCompra/statusFixo/${ordemId}`);

export const getStatusOCFixoOptions = (ocId: string) =>
  getStatusOCFixo(ocId).then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getSteps = (ordemId: string) => api.get<StepsTimeline[]>(`ordemCompra/steps/${ordemId}`);


export const getAllStatusSubcontratacao = () => api.get<Status[]>('status/subcontratacao');
export const getAllStatusSubcontratacaoOptions = () =>
  getAllStatusSubcontratacao().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllStatusOrdemCompraExibicao = () => api.get<Status[]>('status/statusOrdemCompraExibicao');
export const getAllStatusOrdemCompraExibicaoOptions = () =>
  getAllStatusOrdemCompraExibicao().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));

export const getAllStatusOrdemCompra = () => api.get<Status[]>('status/statusOrdemCompra');
export const getAllStatusOrdemCompraOptions = () =>
  getAllStatusOrdemCompra().then(status => (status || []).map(t => ({ text: t.nome, value: t.id.toString() })));